import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO/SEO';
import { industriesData } from '../data/industriesData';
import IndustryCard from '../components/ui/IndustryCard';

const DevelopmentIndustriesPage = () => {
  const seoData = {
    title: "Industries We Serve | Development - Dhyon Technologies",
    description: "Explore our expertise across FinTech, HealthTech, EduTech, SaaS, and more. delivering enterprise-grade digital solutions.",
    keywords: "FinTech, HealthTech, EduTech, SaaS, AgriTech, PropTech, Software Development Industries"
  };

  return (
    <div className="bg-gray-50 min-h-screen pt-20">
      <SEO {...seoData} />

      {/* Hero Section */}
      <section className="bg-[#0F0524] text-white py-20 relative overflow-hidden">
        {/* Abstract Background */}
        <div className="absolute inset-0 overflow-hidden">
             <div className="absolute -top-[50%] -left-[20%] w-[80%] h-[80%] rounded-full bg-purple-900/20 blur-3xl"></div>
             <div className="absolute top-[20%] -right-[20%] w-[60%] h-[60%] rounded-full bg-blue-900/20 blur-3xl"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight">
              Industries <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">We Serve</span>
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto">
              Delivering specialized, scalable, and secure technology solutions tailored for diverse industry needs.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-20 md:py-28 relative">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {industriesData.map((industry, index) => (
              <IndustryCard key={industry.id} industry={industry} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-white py-20 border-t border-gray-100">
        <div className="container mx-auto px-6 text-center">
          <motion.div
             initial={{ opacity: 0, y: 20 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true }}
             className="max-w-3xl mx-auto"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Don't See Your Industry?
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              We build custom solutions for unique business challenges. Let's discuss how we can help you innovate.
            </p>
            <a 
              href="/contact" 
              className="inline-block px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white font-bold rounded-full transition-all transform hover:scale-105 shadow-lg shadow-purple-200"
            >
              Get in Touch
            </a>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default DevelopmentIndustriesPage;
